import React from "react";
import { SvgIcon } from "@mui/material";
import { cleanIconProps } from "./cleanIconProps";

const ExclamationCircleIcon = (props) => {
  return (
    <SvgIcon
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
      {...cleanIconProps(props)}
    >
      <circle
        style={{ ...props.circleStyle }}
        className="exclamation-circle-1"
        cx="148.93406"
        cy="149.23699"
        r="103.12149"
      />
      <path
        className="exclamation-circle-2"
        d="M162.9283,132.08819c.02114-4.22261.04052-28.55364-.01174-32.77067-.126-9.28311-5.84319-15.77277-13.893-15.77277h-.33439c-7.99721.15908-13.63636,6.57157-13.69772,15.60308-.09747,12.73624-.09747,45.77025,0,58.52528.0687,9.13573,5.62476,15.31948,13.814,15.38348,8.32251,0,13.92584-6.08745,14.07762-15.14392.08573-4.54442.06635-9.104.04521-13.659l-.01174-5.8658Z"
      />
      <path
        className="exclamation-circle-2"
        d="M148.95256,187.222h-.254a14.10847,14.10847,0,0,0-13.68833,13.888,14.292,14.292,0,0,0,13.97545,13.819l.60038-.01057c7.3757-.35,13.57471-7.05188,13.25911-14.33275A14.047,14.047,0,0,0,148.95256,187.222Z"
      />
    </SvgIcon>
  );
};

export default ExclamationCircleIcon;
